import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

export function PredefinedMessageFormActions({
  onCancel,
  isValid,
}: {
  onCancel: () => void;
  isValid: boolean;
}) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap gap-2 pt-1">
      <Button type="submit" disabled={!isValid}>
        {t('configuration.predefinedMessages.form.save')}
      </Button>
      <Button type="button" variant="outline" onClick={onCancel}>
        {t('configuration.predefinedMessages.form.cancel')}
      </Button>
    </div>
  );
}
